import { Footer } from '@ifca-root/react-component/src/components/Footer/Footer';
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader';
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper';
import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import { smallTitle } from '@ifca-root/react-component/src/helpers/Global/ContractGlobalVar';
import { useMediaQuery } from '@ifca-root/react-component/src/helpers/PDFFormatter/mediaSize';
import ShareIcon from '@material-ui/icons/Share';
import { Pagination } from '@material-ui/lab';
import { ErrorDialog } from 'components/Dialog/ErrorDialog';
import ShareDialog from 'components/Dialog/ShareDialog';
import {
  useGetPobPurchaseOrderLazyQuery,
  useGetPurchaseOrderLazyQuery,
  useGetShareAttachmentMutation,
  useSubmittedByLedgerQuery,
} from 'generated/graphql';
import {
  buildELetterDrawOptions,
  findFooterBlock,
  getPageContentHeightPx,
  registerPdfExportFonts,
  templateHasFooterBreak,
} from 'helpers/PDFFormatter/pdfExportConfig';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { unstable_batchedUpdates } from 'react-dom';
import { useHistory, useLocation, useParams } from 'react-router';
import '../../../assets/styles/PDFStyle.scss';
import ELetterPreview from '../../ELettering/ELetterTemplate/ELetterPreview';
import {
  CLIENT_CONTRACT,
  DELIVERY_ORDER,
  DETAIL,
  DIRECT_PO,
  GOOD_RETURN_NOTE,
  PROJECT_PURCHASE,
  PURCHASE_ON_BEHALF,
  PURCHASE_ORDER,
  PURCHASE_REQ,
} from '../ProjectPurchaseRoutes';
import {
  DrawOptions,
  Group,
  drawDOM,
  exportPDF,
} from '@progress/kendo-drawing';
import {
  CLIENT_CONTRACT as POB_CLIENT_CONTRACT,
  DELIVERY_ORDER as POB_DELIVERY_ORDER,
  DETAIL as POB_DETAIL,
  DIRECT_PO as POB_DIRECT_PO,
  GOOD_RETURN_NOTE as POB_GOOD_RETURN_NOTE,
  PROJECT_PURCHASE as POB_PROJECT_PURCHASE,
  PURCHASE_ON_BEHALF as POB_PURCHASE_ON_BEHALF,
  PURCHASE_ORDER as POB_PURCHASE_ORDER,
  PURCHASE_REQ as POB_PURCHASE_REQ,
} from '../../POBProjectPurchaseModule/ProjectPurchaseRoutes';

import { usePurchaseQueries } from '../Query/usePurchaseQueries';
import { useGetCurrencySetupQuery } from '@contract-root/admin-react/src/generated/graphql';
import { PDFDocument } from 'pdf-lib';
import saveAs from 'file-saver';

export const PurchasePreviewDetailPDF = (props: any) => {
  const { accountType, docType } = props;
  let history = useHistory();
  let location = useLocation();
  const companyID = localStorage.getItem('companyID');
  const user = JSON.parse(localStorage.getItem('loggedInUser'));

  const projectPurchasePOBSubscriber = JSON.parse(
    localStorage.getItem('projectPurchasePOBSubscriber'),
  );

  const locationState: any = location?.state || null;
  const { id, pId, rfqID, dpoID, dId, gId }: any = useParams();

  const [errMessage, setErrMessage] = useState(null);
  const [errDialog, setErrDialog] = useState(false);

  const [width] = useMediaQuery();

  let fontSize;
  if (width < 769) {
    fontSize = 7;
  } else {
    fontSize = 10;
  }

  let fontStyle = { fontSize: fontSize, textAlign: 'center' };
  let documentName;
  let title;
  let smTitle;
  let creditorOrDebtor;
  let name;
  let itemName;
  let hasItem: boolean;
  let docRefTable: string = 'c_purchaseReq';
  let returnPath: string;
  let transactionID: string;

  smTitle = smallTitle.SUPPLIER_ACCOUNTS;
  creditorOrDebtor = 'CreditorAccount';
  name = 'CompanyName';

  const isPurchaseOrderType =
    docType === 'purchase-order' ||
    docType === 'po-on-behalf' ||
    docType === 'direct-po' ||
    docType === 'direct-po-on-behalf';

  switch (docType) {
    case 'purchase-requisition':
      docRefTable = projectPurchasePOBSubscriber
        ? 'c_projectPOBpurchaseReq'
        : 'c_purchaseReq';
      documentName = 'Purchase Requisition';
      returnPath = `/${
        projectPurchasePOBSubscriber ? POB_CLIENT_CONTRACT : CLIENT_CONTRACT
      }/${id}/${PROJECT_PURCHASE}/${PURCHASE_REQ}/${DETAIL}/${pId}`;
      transactionID = pId;
      title = 'PURCHASE REQUISITION';
      itemName = 'prItem';
      hasItem = true;
      break;
    case 'pr-on-behalf':
      docRefTable = projectPurchasePOBSubscriber
        ? 'c_projectPOBpurchaseReq'
        : 'c_purchaseReq';
      documentName = 'Purchase Requisition';
      returnPath = `/${
        projectPurchasePOBSubscriber ? POB_CLIENT_CONTRACT : CLIENT_CONTRACT
      }/${id}/${PROJECT_PURCHASE}/${PURCHASE_REQ}/${PURCHASE_ON_BEHALF}/${DETAIL}/${pId}`;
      transactionID = pId;
      title = 'PURCHASE REQUISITION';
      itemName = 'prItem';
      hasItem = true;
      break;
    case 'rfq':
      docRefTable = projectPurchasePOBSubscriber ? 'c_projectPOBrfq' : 'c_rfq';
      documentName = 'Request for Quotation';
      returnPath = `/${
        projectPurchasePOBSubscriber ? POB_CLIENT_CONTRACT : CLIENT_CONTRACT
      }/${id}/${PROJECT_PURCHASE}/rfq/${rfqID}/view`;
      transactionID = rfqID;
      title = 'RFQ';
      itemName = 'rfqItem';
      hasItem = true;
      break;
    case 'purchase-order':
      docRefTable = projectPurchasePOBSubscriber
        ? 'c_projectPOBpurchaseOrder'
        : 'c_purchaseOrder';
      documentName = 'Purchase Order';
      returnPath = `/${
        projectPurchasePOBSubscriber ? POB_CLIENT_CONTRACT : CLIENT_CONTRACT
      }/${id}/${PROJECT_PURCHASE}/${PURCHASE_ORDER}/${DETAIL}/${pId}`;
      transactionID = pId;
      title = 'PURCHASE ORDER';
      itemName = 'poItem';
      hasItem = true;
      break;
    case 'po-on-behalf':
      docRefTable = projectPurchasePOBSubscriber
        ? 'c_projectPOBpurchaseOrder'
        : 'c_purchaseOrder';
      documentName = 'Purchase Order';
      returnPath = `/${
        projectPurchasePOBSubscriber ? POB_CLIENT_CONTRACT : CLIENT_CONTRACT
      }/${id}/${PROJECT_PURCHASE}/${PURCHASE_ORDER}/${PURCHASE_ON_BEHALF}/${DETAIL}/${pId}`;
      transactionID = pId;
      title = 'PURCHASE ORDER';
      itemName = 'poItem';
      hasItem = true;
      break;
    case 'direct-po':
      docRefTable = projectPurchasePOBSubscriber
        ? 'c_projectPOBpurchaseOrder'
        : 'c_purchaseOrder';
      documentName = 'Purchase Order';
      returnPath = `/${
        projectPurchasePOBSubscriber ? POB_CLIENT_CONTRACT : CLIENT_CONTRACT
      }/${id}/${PROJECT_PURCHASE}/${DIRECT_PO}/${DETAIL}/${dpoID}`;
      transactionID = dpoID;
      title = 'DIRECT PO';
      itemName = 'poItem';
      hasItem = true;
      break;
    case 'direct-po-on-behalf':
      docRefTable = projectPurchasePOBSubscriber
        ? 'c_projectPOBpurchaseOrder'
        : 'c_purchaseOrder';
      documentName = 'Purchase Order';
      returnPath = `/${
        projectPurchasePOBSubscriber ? POB_CLIENT_CONTRACT : CLIENT_CONTRACT
      }/${id}/${PROJECT_PURCHASE}/${DIRECT_PO}/${PURCHASE_ON_BEHALF}/${DETAIL}/${dpoID}`;
      transactionID = dpoID;
      title = 'DIRECT PO';
      itemName = 'poItem';
      hasItem = true;
      break;
    case 'delivery-order':
      docRefTable = projectPurchasePOBSubscriber ? 'c_projectPOBdo' : 'c_do';
      documentName = 'Good Receive Note';
      returnPath = `/${
        projectPurchasePOBSubscriber ? POB_CLIENT_CONTRACT : CLIENT_CONTRACT
      }/${id}/${PROJECT_PURCHASE}/${DELIVERY_ORDER}/${DETAIL}/${dId}`;
      transactionID = dId;
      title = 'GOOD RECEIVE NOTE';
      itemName = 'doItem';
      hasItem = true;
      break;
    case 'good-return-note':
      docRefTable = projectPurchasePOBSubscriber
        ? 'c_projectPOBgrtn'
        : 'c_grtn';
      documentName = 'Good Return Note';
      returnPath = `/${
        projectPurchasePOBSubscriber ? POB_CLIENT_CONTRACT : CLIENT_CONTRACT
      }/${id}/${PROJECT_PURCHASE}/${GOOD_RETURN_NOTE}/${DETAIL}/${gId}`;
      transactionID = gId;
      title = 'GOOD RETURN NOTE';
      itemName = 'goodReturnNoteItem';
      hasItem = true;
      break;
  }

  const {
    loading: subByLoading,
    data: { submittedByLedger } = { submittedByLedger: '' },
  } = useSubmittedByLedgerQuery({
    fetchPolicy: 'network-only',
    variables: { docRefTable, docRefID: transactionID },
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrMessage(error);
      setErrDialog(true);
    },
  });

  const {
    loading: currencySetupLoading,
    error: currencySetupError,
    data: { getCurrencySetup } = { getCurrencySetup: [] },
  } = useGetCurrencySetupQuery({
    fetchPolicy: 'network-only',
    variables: { id: id },
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrDialog(true);
      setErrMessage(error);
    },
  });

  const {
    loading,
    listData,
    watermarkData,
    attachmentData,
    primaryKey,
    templateBody,
    letterTemplateLoading,
    approvalLogData,
    approvalLogLoading,
  } = usePurchaseQueries({
    accountType,
    docType,
    companyID,
    transactionID: transactionID,
    setErrMessage,
    setErrDialog,
    projectPurchasePOBSubscriber,
  });

  const [prefetchPurchaseOrder] = useGetPurchaseOrderLazyQuery({
    fetchPolicy: 'network-only',
    onError: () => {},
  });
  const [prefetchPOBPurchaseOrder] = useGetPobPurchaseOrderLazyQuery({
    fetchPolicy: 'network-only',
    onError: () => {},
  });

  useEffect(() => {
    if (!isPurchaseOrderType || !transactionID) return;
    const duplicateContractID = sessionStorage.getItem('forDuplicateItem');
    projectPurchasePOBSubscriber
      ? prefetchPOBPurchaseOrder({
          variables: {
            ID: transactionID,
            contractID:
              duplicateContractID !== null ? duplicateContractID : id,
          },
        })
      : prefetchPurchaseOrder({
          variables: { ID: transactionID, contractID: id },
        });
  }, [transactionID]);

  const previewDetail: any =
    listData?.length > 0 && getCurrencySetup?.length > 0
      ? {
          ...listData?.filter(v => v?.[primaryKey] === transactionID)?.[0],
          ['currencyByDoc']: getCurrencySetup?.find(
            e =>
              e?.ID ===
              listData?.filter(v => v?.[primaryKey] === transactionID)?.[0]
                ?.currencyID,
          ),
        }
      : listData?.filter(v => v?.[primaryKey] === transactionID)?.[0];

  // ========== Page definition ==========
  const [page, setCurrentPage] = useState<number>(0);

  // ========== Remap Data for item list ==========
  const [remapData, setRemapData] = useState(null);
  const [poWithRepeatedHeaders, setPoWithRepeatedHeaders] = useState(null);
  // Items per page, shrunk until every hidden page fits one A4 export page
  const [itemsPerPageFit, setItemsPerPageFit] = useState<number | null>(null);
  // When the footer-bearing last page cannot fit one A4 page even after item
  // shrinking, the footer moves to its own page so [PageNo]/[TotalPage]
  // match the physical page count
  const [footerOnOwnPage, setFooterOnOwnPage] = useState(false);
  // The template footer carries a manual <!-- pagebreak --> - everything
  // from the marker onward (remarks/signatory) prints on its own page,
  // counted in [PageNo]/[TotalPage] and headed like every other page
  const footerHasBreak = useMemo(
    () => isPurchaseOrderType && templateHasFooterBreak(templateBody),
    [templateBody],
  );
  // Per-item parts (original item position -> remark line count per
  // part): an item is split into parts when its text alone exceeds one
  // page, or at the bottom of a page so its first lines fill the leftover
  // space; every part renders under a repeated document header and the
  // amounts print on the first part only
  const [itemPartLines, setItemPartLines] = useState<
    Record<number, number[]>
  >({});
  // Page plan for PO-type docs: which printed items go on which page
  // (positions in the split item list). Starts with every item on one
  // page; the fit effect keeps moving overflow items to the next page
  // until every page fits one A4 export page, so short items share pages
  // instead of a fixed items-per-page count
  const [pagePlan, setPagePlan] = useState<number[][] | null>(null);
  // Space-reclaim bookkeeping: once every page fits, try pulling the next
  // page's first item back to fill unused space, one page gap at a time.
  // doNotPullRef lists items that must never be pulled (again); keys are
  // `origIdx:partIdx` strings so they stay valid when a new part shifts
  // the printed positions. pendingPullRef is the pull we are waiting to
  // measure - kept if the page fits, undone otherwise.
  const doNotPullRef = useRef<Set<string>>(new Set());
  const pendingPullRef = useRef<{ pageIdx: number; printIdx: number } | null>(
    null,
  );
  // A page-fill in progress: when a pulled item does not fit, it is cut so
  // its first remark lines fill the page; keptLines is adjusted over a few
  // measure passes until the page is as full as it can get
  const pendingFillRef = useRef<{
    pageIdx: number;
    origIdx: number;
    partIdx: number;
    totalLines: number;
    keptLines: number;
    prevKeptLines: number;
    prevHeight: number;
    tries: number;
  } | null>(null);
  // One-shot attempt to move the footer back onto the last item page after
  // packing finishes (if the page then overflows, the footer splits off
  // again and this ref stops a second attempt)
  const footerMergeTriedRef = useRef(false);
  // True once a measure pass finds nothing left to change - until then the
  // export buttons stay disabled and a loading overlay shows
  const [layoutSettled, setLayoutSettled] = useState(false);
  const [exporting, setExporting] = useState(false);

  // A page-fill cut never leaves fewer remark lines than this on either
  // side of the cut (a too-big-for-one-page item may still go below it)
  const MIN_LINES_PER_PART = 2;
  const MAX_PARTS_PER_ITEM = 20;

  const partKey = (
    item: { __origIdx?: number; __partIdx?: number } | undefined,
    printIdx: number,
  ) =>
    item?.__origIdx != null
      ? `${item.__origIdx}:${item.__partIdx ?? 0}`
      : `e${printIdx}`;

  // Rendered description of a PO item - mirrors the [itemDescription]
  // param source in ELetterServicePurchase
  const getItemDescription = (item: {
    costItem?: {
      name?: string;
      costCategory?: { name?: string; costClass?: string };
    };
  }) =>
    (item?.costItem?.costCategory?.costClass === 'SUBCONTRACT'
      ? item?.costItem?.costCategory?.name
      : item?.costItem?.name) ?? '';

  // Break a description into word-wrapped pseudo-lines so a very long
  // description can split across pages like remark lines do; the width is
  // an estimate - the measure passes correct any error
  const DESC_WRAP_CHARS = 90;
  const wrapTextToLines = (text: string): string[] => {
    const lines: string[] = [];
    let line = '';
    text
      .split(/\s+/)
      .filter(Boolean)
      .forEach(word => {
        if (line && line.length + 1 + word.length > DESC_WRAP_CHARS) {
          lines.push(line);
          line = word;
        } else {
          line = line ? `${line} ${word}` : word;
        }
      });
    if (line) lines.push(line);
    return lines;
  };

  // The splittable text of a rendered part: its description portion
  // (pseudo-lines) followed by its remark lines
  const getPartFlowLines = (part: {
    __partIdx?: number;
    __descriptionOverride?: string;
    remarks?: string;
    costItem?: {
      name?: string;
      costCategory?: { name?: string; costClass?: string };
    };
  }): string[] => {
    const desc =
      part?.__descriptionOverride ??
      ((part?.__partIdx ?? 0) === 0 ? getItemDescription(part) : '');
    return wrapTextToLines(desc).concat((part?.remarks ?? '').split('\n'));
  };

  // Split remark lines into `parts` groups of roughly equal rendered
  // height (longer lines count for more); returns the line count per group
  const splitLinesEvenly = (lines: string[], parts: number): number[] => {
    const weight = (line: string) => Math.max(line.length, 1);
    const total = lines.reduce((sum, line) => sum + weight(line), 0);
    const counts = [0];
    let cumulative = 0;
    lines.forEach(line => {
      counts[counts.length - 1]++;
      cumulative += weight(line);
      if (
        counts.length < parts &&
        cumulative >= (total * counts.length) / parts
      ) {
        counts.push(0);
      }
    });
    return counts.filter(count => count > 0);
  };

  // Turn each item into its parts per itemPartLines (line counts per
  // part). The split flow is the description pseudo-lines followed by the
  // remark lines, so a page-long description can split across pages too;
  // the last part takes any leftover lines so none are lost
  const splitItemsIntoParts = rawItems => {
    if (!rawItems?.length) return rawItems;
    const expanded = [];
    rawItems.forEach((item, origIdx) => {
      const counts = itemPartLines[origIdx];
      const descLines = wrapTextToLines(getItemDescription(item));
      const remarkLines = (item?.remarks ?? '').split('\n');
      const flowLength = descLines.length + remarkLines.length;
      if (!counts || counts.length <= 1 || flowLength < 2) {
        expanded.push({ ...item, __origIdx: origIdx, __partIdx: 0 });
        return;
      }
      // Only override the printed description when a cut actually falls
      // inside it - otherwise the param map's own source stays in charge
      let boundary = 0;
      const descSplit = counts.slice(0, -1).some(count => {
        boundary += count;
        return boundary > 0 && boundary < descLines.length;
      });
      let cursor = 0;
      counts.forEach((count, partIdx) => {
        const isLast = partIdx === counts.length - 1;
        const start = cursor;
        const end = isLast
          ? flowLength
          : Math.min(cursor + count, flowLength);
        cursor = end;
        if (end <= start) return;
        const descPart = descLines.slice(
          Math.min(start, descLines.length),
          Math.min(end, descLines.length),
        );
        const remarkPart = remarkLines.slice(
          Math.max(0, start - descLines.length),
          Math.max(0, end - descLines.length),
        );
        expanded.push({
          ...item,
          remarks: remarkPart.join('\n'),
          ...(descSplit
            ? { __descriptionOverride: descPart.join(' ') }
            : {}),
          __origIdx: origIdx,
          __partIdx: partIdx,
          __continuation: partIdx > 0,
        });
      });
    });
    return expanded;
  };

  const separateThreshold = input => {
    // Layout will change - block exports until the fit effect settles
    setLayoutSettled(false);

    // CX-3631: For RFQ Specifically, generates 1 page for each supplier
    // Use remapData length to support generation for each supplier
    if (docType === 'rfq' && Array.isArray(input?.supplier)) {
      const supplierCount = input.supplier.length;
      if (supplierCount > 0) {
        const supplierPages = input.supplier.map((_, idx) => ({
          ...input,
          PageNo: idx + 1,
          TotalPage: supplierCount,
          pageNumber: idx + 1,
          totalPages: supplierCount,
        }));
        setRemapData(supplierPages);
        return;
      }
    }

    if (!!hasItem && input?.[itemName]) {
      // For purchase orders: 10 items per page, for others: 500; shrunk by
      // the fit-measurement effect until every page fits one A4 export page
      const itemsPerPage =
        itemsPerPageFit ?? (isPurchaseOrderType ? 10 : 500);

      // PO-type docs: split items into their parts (driven by the
      // fit-measurement effect)
      const items = isPurchaseOrderType
        ? splitItemsIntoParts(
            [...input[itemName]].sort(
              (a, b) => (a?.sequence ?? 0) - (b?.sequence ?? 0),
            ),
          )
        : input[itemName];
      const pages = [];

      // Which printed items go on which page: PO types follow the
      // measured page plan; other doc types use a fixed count per page
      const groups: number[][] = [];
      if (isPurchaseOrderType) {
        const planValid =
          !!pagePlan &&
          pagePlan.length > 0 &&
          pagePlan.every(group => group.length > 0) &&
          pagePlan.flat().length === items.length &&
          pagePlan.flat().every(ix => ix >= 0 && ix < items.length);
        if (planValid) {
          pagePlan.forEach(group => groups.push(group));
        } else if (items.length > 0) {
          // Start with everything on one page; the fit effect moves the
          // overflow onto following pages
          groups.push(items.map((_, ix) => ix));
        }
      } else {
        for (let i = 0; i < items.length; i += itemsPerPage) {
          groups.push(items.slice(i, i + itemsPerPage).map((_, k) => i + k));
        }
      }

      // Footer on its own page: item pages keep only items and the footer
      // renders alone on one extra last page (which then always fits, so
      // the page count matches the printed PDF)
      const splitFooter = footerOnOwnPage && items.length > 0;
      // Manual page break inside the footer: the content after the marker
      // (remarks/signatory) prints on one extra page after everything else
      const breakPage = footerHasBreak && items.length > 0;
      const plannedPageCount =
        Math.max(1, groups.length) +
        (splitFooter ? 1 : 0) +
        (breakPage ? 1 : 0);
      // Page number of the page bearing the footer's before-break part
      const footerPageNo = Math.max(1, groups.length) + (splitFooter ? 1 : 0);

      const buildPageItems = (group: number[]) =>
        group.map((printIdx, index) => {
          const item = items[printIdx];
          return {
            ...item,
            __printIdx: printIdx,
            // Continuation parts keep the original item number
            index: item.__origIdx != null ? item.__origIdx + 1 : printIdx + 1,
            pageIndex: index + 1, // Local index within page
          };
        });

      groups.forEach((group, gi) => {
        pages.push({
          ...input,
          [itemName]: buildPageItems(group),
          pageNumber: gi + 1,
          totalPages: plannedPageCount,
          footerBeforeBreak:
            breakPage && !splitFooter && gi === groups.length - 1,
        });
      });

      if (splitFooter) {
        pages.push({
          ...input,
          [itemName]: [],
          footerOnlyPage: true,
          footerBeforeBreak: breakPage,
          pageNumber: footerPageNo,
          totalPages: plannedPageCount,
        });
      }

      if (breakPage) {
        pages.push({
          ...input,
          [itemName]: [],
          footerOnlyPage: true,
          footerAfterBreakPage: true,
          pageNumber: plannedPageCount,
          totalPages: plannedPageCount,
        });
      }

      setRemapData(pages.length > 0 ? pages : [{ ...input, [itemName]: [] }]);

      if (isPurchaseOrderType) {
        const poPages = [];
        groups.forEach((group, gi) => {
          const currentPage = gi + 1;
          const totalPages = plannedPageCount;
          const isLastPage = currentPage === totalPages;
          const footerBeforeBreak =
            breakPage && !splitFooter && gi === groups.length - 1;

          poPages.push({
            ...input,
            docNo: input.docNo,
            docDate: input.docDate,
            supplierName: input.supplierName,
            supplierAddress: input.supplierAddress,
            contactNo: input.contactNo,
            contractTitle: input.contractTitle,
            deliveryDate: input.deliveryDate,
            preparedBy: input.preparedBy,
            requestedBy: input.requestedBy,
            paymentTerm: input.paymentTerm,
            companyName: input.companyName,
            companyRegNo: input.companyRegNo,
            companyGstNo: input.companyGstNo,
            companySstNo: input.companySstNo,
            companyAddress: input.companyAddress,
            companyContactNo: input.companyContactNo,
            companyCurrencyCode:
              input.companyCurrencyCode || user?.companyCurrencyCode,
            sumTaxAmt: input.sumTaxAmt,
            sumBaseAmt: input.sumBaseAmt,
            sumTotalAmt: input.sumTotalAmt,
            totalAmtInWords: input.totalAmtInWords,
            specialInstruction: input.specialInstruction,
            termsConditions: input.termsConditions,
            deliveryLocation: input.deliveryLocation,
            contactPerson: input.contactPerson,
            remarks: input.remarks,
            currency: input.currency || user?.companyCurrencyCode,

            // Page specific data
            [itemName]: buildPageItems(group),
            PageNo: currentPage,
            TotalPage: totalPages,
            pageNumber: currentPage,
            totalPages: totalPages,

            hideFooterOnThisPage: !(isLastPage || footerBeforeBreak),
            isLastPage: isLastPage,
            footerBeforeBreak,
          });
        });

        if (splitFooter) {
          poPages.push({
            ...input,
            [itemName]: [],
            footerOnlyPage: true,
            footerBeforeBreak: breakPage,
            PageNo: footerPageNo,
            TotalPage: plannedPageCount,
            pageNumber: footerPageNo,
            totalPages: plannedPageCount,
            hideFooterOnThisPage: false,
            isLastPage: !breakPage,
          });
        }

        if (breakPage) {
          poPages.push({
            ...input,
            [itemName]: [],
            footerOnlyPage: true,
            footerAfterBreakPage: true,
            PageNo: plannedPageCount,
            TotalPage: plannedPageCount,
            pageNumber: plannedPageCount,
            totalPages: plannedPageCount,
            hideFooterOnThisPage: false,
            isLastPage: true,
          });
        }
        setPoWithRepeatedHeaders(poPages.length > 0 ? poPages : [input]);
      }
    } else {
      setRemapData([{ ...input }]);
      if (isPurchaseOrderType) {
        setPoWithRepeatedHeaders([input]);
      }
    }
  };

  const finalPdf = async (
    dataURI: string,
    isAttached: boolean,
    attachFileURL?: string,
  ): Promise<Blob | null> => {
    try {
      // No attachment -> return generated PDF as Blob
      if (!isAttached || !attachFileURL) {
        return await fetch(dataURI).then(res => res.blob());
      }

      // Generated PDF
      const generatedPdfBytes = await fetch(dataURI).then(res =>
        res.arrayBuffer(),
      );

      // Attachment PDF
      const attachmentResponse = await fetch(attachFileURL);

      if (!attachmentResponse.ok) {
        throw new Error(
          `Failed to load attachment PDF (${attachmentResponse.status})`,
        );
      }

      const attachmentPdfBytes = await attachmentResponse.arrayBuffer();

      // Load PDFs
      const generatedPdf = await PDFDocument.load(generatedPdfBytes);
      const attachmentPdf = await PDFDocument.load(attachmentPdfBytes);

      // Create merged PDF
      const mergedPdf = await PDFDocument.create();

      // A4 in PDF points - the previous 794x1123 (CSS px) produced oversized
      // pages with the real content shrunk and pasted onto them
      const A4_WIDTH = 595.28;
      const A4_HEIGHT = 841.89;

      const addPdfPages = async (sourcePdf: PDFDocument) => {
        const pages = await mergedPdf.copyPages(
          sourcePdf,
          sourcePdf.getPageIndices(),
        );

        for (const page of pages) {
          const embeddedPage = await mergedPdf.embedPage(page);

          const originalWidth = page.getWidth();
          const originalHeight = page.getHeight();

          const scale = Math.min(
            A4_WIDTH / originalWidth,
            A4_HEIGHT / originalHeight,
          );

          const width = originalWidth * scale;
          const height = originalHeight * scale;

          const x = (A4_WIDTH - width) / 2;
          const y = (A4_HEIGHT - height) / 2;

          const newPage = mergedPdf.addPage([A4_WIDTH, A4_HEIGHT]);

          newPage.drawPage(embeddedPage, {
            x,
            y,
            width,
            height,
          });
        }
      };

      // Generated PDF FIRST
      await addPdfPages(generatedPdf);

      // Attachment PDF SECOND
      await addPdfPages(attachmentPdf);

      const mergedPdfBytes: any = await mergedPdf.save();

      return new Blob([mergedPdfBytes], {
        type: 'application/pdf',
      });
    } catch (error) {
      console.error('PDF generation failed:', error);
      return null;
    }
  };

  const landhonCompanyID = 'b18e8e32-c682-11f0-97e7-3ff9c5e2fd2e';

  // Client-side (Kendo drawing) export at the fixed shared scale
  const buildKendoPdfDataURI = async (isSupplierSubcon?: boolean) => {
    // CJK-capable embedded fonts - without this, Chinese text exports as
    // garbage glyphs (the PDF writer has no browser-style font fallback)
    registerPdfExportFonts();
    const element = document.getElementById('pdf-data-print-wrapper');

    const landhonCompanyScalling: DrawOptions = {
      paperSize: [794, 1123],
      scale: 1,
      margin: {
        top: '0mm',
        bottom: '0mm',
        left: '0mm',
        right: '0mm',
      },
      forcePageBreak: '.page-break',
      repeatHeaders: true,
    };

    const group = await drawDOM(
      element,
      companyID === landhonCompanyID &&
        documentName === 'Payment' &&
        !!isSupplierSubcon
        ? landhonCompanyScalling
        : buildELetterDrawOptions(
            element
              ? Math.max(element.scrollWidth, element.offsetWidth)
              : undefined,
          ),
    );

    return exportPDF(group);
  };

  const exportFailed = (error: unknown) => {
    setErrMessage(
      error instanceof Error && error.message
        ? error.message
        : 'PDF export failed. Please try again.',
    );
    setErrDialog(true);
  };

  const onPrint = async (isSupplierSubcon?: boolean) => {
    setExporting(true);
    try {
      const dataURI = await buildKendoPdfDataURI(isSupplierSubcon);

      const fileObject = await finalPdf(
        dataURI,
        attachmentData?.is_attached_file,
        attachmentData?.file?.fileURL,
      );
      if (!fileObject) throw new Error('PDF generation failed');

      saveAs(fileObject, `${title} (${previewDetail?.docNo}).pdf`);
    } catch (error) {
      exportFailed(error);
    } finally {
      setExporting(false);
    }
  };

  const onShare = async (
    filename = 'document.pdf',
    isSupplierSubcon?: boolean,
  ): Promise<File | null> => {
    setExporting(true);
    try {
      const dataURI = await buildKendoPdfDataURI(isSupplierSubcon);

      const blob = await finalPdf(
        dataURI,
        attachmentData?.is_attached_file,
        attachmentData?.file?.fileURL,
      );
      if (!blob) throw new Error('PDF generation failed');

      return new File([blob], filename, { type: 'application/pdf' });
    } catch (error) {
      exportFailed(error);
      return null;
    } finally {
      setExporting(false);
    }
  };

  useEffect(() => {
    if (!!previewDetail && remapData === null) {
      separateThreshold(previewDetail);
    }
  }, [previewDetail]);

  // Rebuild the pages when the fitted page size, split-off footer page,
  // item parts or page plan change
  useEffect(() => {
    if (
      !!previewDetail &&
      (itemsPerPageFit !== null ||
        footerOnOwnPage ||
        pagePlan !== null ||
        Object.keys(itemPartLines).length > 0 ||
        footerHasBreak)
    ) {
      setCurrentPage(0);
      separateThreshold(previewDetail);
    }
  }, [itemsPerPageFit, footerOnOwnPage, itemPartLines, pagePlan, footerHasBreak]);

  // Shrink itemsPerPage until every hidden page fits one A4 page at the
  // export scale, so the exported PDF paginates exactly like the preview
  useEffect(() => {
    if (docType === 'rfq') {
      // Per-supplier pages never change layout
      setLayoutSettled(true);
      return;
    }
    const wrapper = document.getElementById('pdf-data-print-wrapper');
    if (!wrapper) return;

    let rafID: number | null = null;
    const measure = () => {
      if (rafID !== null) cancelAnimationFrame(rafID);
      rafID = requestAnimationFrame(() => {
        const pages = Array.from(
          wrapper.querySelectorAll('[id^="pdf-data-print-"]'),
        );
        if (pages.length === 0) return;
        const heights = pages.map(p => (p as HTMLElement).scrollHeight);
        const maxHeight = Math.max(...heights);
        // Page capacity follows the measured template width - company
        // templates are not guaranteed 850px wide
        const templateWidth = Math.max(
          ...pages.map(p =>
            Math.max(
              (p as HTMLElement).scrollWidth,
              (p as HTMLElement).offsetWidth,
            ),
          ),
        );
        const capacity = getPageContentHeightPx(templateWidth);
        const current = itemsPerPageFit ?? (isPurchaseOrderType ? 10 : 500);
        const plannedPages = isPurchaseOrderType
          ? poWithRepeatedHeaders
          : remapData;
        // A manual footer break renders its after-break page last, but the
        // page whose overflow matters is the one bearing the totals part
        const restPageCount =
          plannedPages?.filter(p => p?.footerAfterBreakPage)?.length ?? 0;
        const footerPageIdx = Math.max(0, heights.length - 1 - restPageCount);
        // The footer renders on the last page only. When that page overflows
        // while the item pages fit (or no further shrinking is possible),
        // move the footer to its own page instead of shrinking items
        const lastHeight = heights[footerPageIdx];
        const itemPagesFit = heights
          .slice(0, footerPageIdx)
          .every(h => h <= capacity);
        // An unfinished pull or page-fill may be what overflowed the
        // footer page; let that resolve below before splitting the footer
        if (
          !footerOnOwnPage &&
          !pendingPullRef.current &&
          !pendingFillRef.current &&
          (restPageCount === 0 || plannedPages?.length === pages.length) &&
          lastHeight > capacity &&
          (itemPagesFit || current <= 1)
        ) {
          setFooterOnOwnPage(true);
          return;
        }

        // PO types: an overflowing page with several items moves its last
        // items onto the next page; an overflowing page with a single item
        // splits that item's remark text into parts (each part renders as a
        // full page with the document header repeated)
        if (isPurchaseOrderType) {
          // Hidden pages are still rendering and do not match the plan yet
          // - wait, the MutationObserver measures again when they change
          if (plannedPages?.length !== pages.length) return;
          const itemPages: {
            height: number;
            pageItems: {
              __printIdx?: number;
              __origIdx?: number;
              __partIdx?: number;
              __continuation?: boolean;
              __descriptionOverride?: string;
              index?: number;
              remarks?: string;
            }[];
          }[] = [];
          let aligned = true;
          plannedPages.forEach((plannedPage, i) => {
            if (plannedPage?.footerOnlyPage) return;
            const pageItems = plannedPage?.[itemName] ?? [];
            if (pageItems.some(item => item?.__printIdx == null)) {
              aligned = false;
            }
            itemPages.push({ height: heights[i], pageItems });
          });
          if (!aligned || itemPages.length === 0) return;

          const itemByPrintIdx = new Map<
            number,
            {
              __origIdx?: number;
              __partIdx?: number;
              __continuation?: boolean;
            }
          >();
          itemPages.forEach(p =>
            p.pageItems.forEach(item => itemByPrintIdx.set(item.__printIdx, item)),
          );

          // A page-fill in progress: adjust how many remark lines stay on
          // the filled page using the measured heights, then finish
          if (pendingFillRef.current) {
            const fill = pendingFillRef.current;
            const filledPage = itemPages[fill.pageIdx];
            if (!filledPage) {
              // The plan was rebuilt from scratch meanwhile - stop the fill
              pendingFillRef.current = null;
            } else {
              const newHeight = filledPage.height;
              const lineHeight =
                fill.prevKeptLines !== fill.keptLines
                  ? (fill.prevHeight - newHeight) / (fill.prevKeptLines - fill.keptLines)
                  : 0;
              const linesToAdd =
                lineHeight > 0
                  ? Math.floor((capacity - newHeight) / lineHeight)
                  : newHeight > capacity
                  ? -1
                  : 0;
              let nextKeptLines = Math.min(
                fill.totalLines - MIN_LINES_PER_PART,
                fill.keptLines + linesToAdd,
              );
              if (newHeight > capacity && nextKeptLines >= fill.keptLines) nextKeptLines = fill.keptLines - 1;
              if (newHeight > capacity && nextKeptLines < MIN_LINES_PER_PART) {
                // Not even the minimum lines fit - undo the cut and move
                // the whole item forward
                const filledItems = filledPage.pageItems;
                const firstIdx = filledItems[filledItems.length - 1]?.__printIdx;
                doNotPullRef.current.add(
                  `${fill.origIdx}:${fill.partIdx}`,
                );
                pendingFillRef.current = null;
                const merged = itemPages
                  .map(p => p.pageItems.map(item => item.__printIdx))
                  .map(group => group.filter(ix => ix !== firstIdx))
                  .map(group =>
                    group.map(ix => (ix > firstIdx ? ix - 1 : ix)),
                  );
                unstable_batchedUpdates(() => {
                  setItemPartLines(prev => {
                    const counts = [...(prev[fill.origIdx] ?? [])];
                    counts.splice(fill.partIdx, 2, fill.totalLines);
                    if (counts.length <= 1) {
                      const next = { ...prev };
                      delete next[fill.origIdx];
                      return next;
                    }
                    return { ...prev, [fill.origIdx]: counts };
                  });
                  setPagePlan(merged.filter(group => group.length > 0));
                });
                return;
              }
              if (newHeight <= capacity && (nextKeptLines <= fill.keptLines || fill.tries >= 4)) {
                // Page is filled - the item's remaining lines must start
                // the next page, so never pull them back up
                doNotPullRef.current.add(
                  `${fill.origIdx}:${fill.partIdx + 1}`,
                );
                pendingFillRef.current = null;
                // Fall through - the pass continues with the final plan
              } else {
                nextKeptLines = Math.max(MIN_LINES_PER_PART, nextKeptLines);
                pendingFillRef.current = {
                  ...fill,
                  prevKeptLines: fill.keptLines,
                  prevHeight: newHeight,
                  keptLines: nextKeptLines,
                  tries: fill.tries + 1,
                };
                setItemPartLines(prev => {
                  const counts = [...(prev[fill.origIdx] ?? [fill.totalLines])];
                  counts.splice(
                    fill.partIdx,
                    2,
                    nextKeptLines,
                    fill.totalLines - nextKeptLines,
                  );
                  return { ...prev, [fill.origIdx]: counts };
                });
                return;
              }
            }
          }

          const updatedPartLines: Record<number, number[]> = { ...itemPartLines };
          let partsChanged = false;
          const newPlan = itemPages.map(p =>
            p.pageItems.map(item => item.__printIdx),
          );
          let planChanged = false;
          let fillStarted = false;
          // Check the waiting pull: if the page fits, the pulled item
          // stays; if it overflows, the fill/undo below handles it
          if (pendingPullRef.current) {
            const pulledPage = itemPages[pendingPullRef.current.pageIdx];
            if (!pulledPage || pulledPage.height <= capacity) {
              pendingPullRef.current = null;
            }
          }
          itemPages.forEach(({ height: h, pageItems }, i) => {
            if (h <= capacity || fillStarted) return;
            // The pulled item did not fit: cut it so its first remark
            // lines fill this page and the rest continues on the next page
            // under a repeated header; items too short to cut (fewer than
            // 2 lines per side) move back whole and are never pulled again
            if (
              pendingPullRef.current?.pageIdx === i &&
              pageItems[pageItems.length - 1]?.__printIdx ===
                pendingPullRef.current.printIdx
            ) {
              const pulledItem = pageItems[pageItems.length - 1];
              const printIdx = pendingPullRef.current.printIdx;
              pendingPullRef.current = null;
              const pulledItemLines = getPartFlowLines(pulledItem).length;
              const origIdx = pulledItem?.__origIdx;
              const partIdx = pulledItem?.__partIdx ?? 0;
              const partCount =
                origIdx != null ? itemPartLines[origIdx]?.length ?? 1 : 1;
              if (
                origIdx != null &&
                pulledItemLines >= MIN_LINES_PER_PART * 2 &&
                partCount < MAX_PARTS_PER_ITEM
              ) {
                const keptLines = Math.min(
                  pulledItemLines - MIN_LINES_PER_PART,
                  Math.max(MIN_LINES_PER_PART, Math.floor(pulledItemLines / 2)),
                );
                pendingFillRef.current = {
                  pageIdx: i,
                  origIdx,
                  partIdx,
                  totalLines: pulledItemLines,
                  keptLines,
                  prevKeptLines: pulledItemLines,
                  prevHeight: h,
                  tries: 0,
                };
                const shifted = newPlan.map(group =>
                  group.map(ix => (ix > printIdx ? ix + 1 : ix)),
                );
                if (!shifted[i + 1]) shifted.splice(i + 1, 0, []);
                shifted[i + 1].unshift(printIdx + 1);
                fillStarted = true;
                unstable_batchedUpdates(() => {
                  setItemPartLines(prev => {
                    const counts = [...(prev[origIdx] ?? [pulledItemLines])];
                    counts.splice(
                      partIdx,
                      1,
                      keptLines,
                      pulledItemLines - keptLines,
                    );
                    return { ...prev, [origIdx]: counts };
                  });
                  setPagePlan(shifted.filter(group => group.length > 0));
                });
                return;
              }
              // Undo the pull exactly: move only the pulled item back
              doNotPullRef.current.add(partKey(pulledItem, printIdx));
              const rolledBack = newPlan[i].splice(newPlan[i].length - 1, 1);
              if (!newPlan[i + 1]) newPlan.push([]);
              newPlan[i + 1].unshift(...rolledBack);
              planChanged = true;
              return;
            }
            if (pageItems.length === 1) {
              const pageItem = pageItems[0];
              const origIdx =
                pageItem?.__origIdx != null
                  ? pageItem.__origIdx
                  : (pageItem?.index ?? 1) - 1;
              const partIdx = pageItem?.__partIdx ?? 0;
              const partLines = getPartFlowLines(pageItem);
              const counts = updatedPartLines[origIdx]
                ? [...updatedPartLines[origIdx]]
                : [partLines.length];
              // Only split while the part still has lines to give
              if (partLines.length >= 2 && counts.length < MAX_PARTS_PER_ITEM) {
                const halves = splitLinesEvenly(partLines, 2);
                counts.splice(partIdx, 1, halves[0], halves[1]);
                updatedPartLines[origIdx] = counts;
                partsChanged = true;
              }
              return;
            }
            // Estimate how many of the last items to move to the next
            // page; always keep at least one, and move slightly fewer
            // than needed so pages end up as full as possible
            const moveCount = Math.min(
              pageItems.length - 1,
              Math.max(
                1,
                Math.floor((pageItems.length * (h - capacity)) / h),
              ),
            );
            const moved = newPlan[i].splice(
              newPlan[i].length - moveCount,
              moveCount,
            );
            if (!newPlan[i + 1]) newPlan.push([]);
            newPlan[i + 1].unshift(...moved);
            planChanged = true;
          });
          // A page-fill already updated the part lines and the plan
          if (fillStarted) return;
          // New parts shift every printed position, so the plan and the
          // pull/merge memory no longer apply - save and replan next pass
          if (partsChanged) {
            doNotPullRef.current = new Set();
            pendingPullRef.current = null;
            pendingFillRef.current = null;
            footerMergeTriedRef.current = false;
            setItemPartLines(updatedPartLines);
            return;
          }
          if (planChanged) {
            setPagePlan(newPlan.filter(group => group.length > 0));
            return;
          }

          // Two consecutive parts of the same item sharing a fitting page
          // mean the split is not needed there anymore (an item shows as
          // two rows with the same item number) - merge them back into one
          // row; a continuation part should only ever START a page
          for (let p = 0; p < itemPages.length; p++) {
            const { height: h, pageItems } = itemPages[p];
            if (h > capacity) continue;
            for (let k = 1; k < pageItems.length; k++) {
              const prevPart = pageItems[k - 1];
              const currPart = pageItems[k];
              if (
                !currPart?.__continuation ||
                prevPart?.__origIdx == null ||
                prevPart.__origIdx !== currPart.__origIdx ||
                (prevPart.__partIdx ?? 0) + 1 !== (currPart.__partIdx ?? 0)
              ) {
                continue;
              }
              const origIdx = currPart.__origIdx;
              const firstPartIdx = prevPart.__partIdx ?? 0;
              const removedIdx = currPart.__printIdx;
              const mergedPlan = newPlan
                .map(group => group.filter(ix => ix !== removedIdx))
                .map(group =>
                  group.map(ix => (ix > removedIdx ? ix - 1 : ix)),
                );
              unstable_batchedUpdates(() => {
                setItemPartLines(prevLines => {
                  const counts = [...(prevLines[origIdx] ?? [])];
                  if (firstPartIdx + 1 < counts.length) {
                    counts.splice(
                      firstPartIdx,
                      2,
                      counts[firstPartIdx] + counts[firstPartIdx + 1],
                    );
                  }
                  if (counts.length <= 1) {
                    const next = { ...prevLines };
                    delete next[origIdx];
                    return next;
                  }
                  return { ...prevLines, [origIdx]: counts };
                });
                setPagePlan(mergedPlan.filter(group => group.length > 0));
              });
              return;
            }
          }

          // Every page fits: try filling leftover space by pulling the
          // next page's first item back (first page gap not yet tried);
          // the next measure pass keeps it (fits), cuts it to fill the
          // page (does not fit but can be cut) or moves it back (too short
          // to cut)
          for (let i = 0; i < newPlan.length - 1; i++) {
            const candidate = newPlan[i + 1][0];
            const candItem = itemByPrintIdx.get(candidate);
            if (doNotPullRef.current.has(partKey(candItem, candidate))) {
              continue;
            }
            newPlan[i].push(candidate);
            newPlan[i + 1].shift();
            pendingPullRef.current = { pageIdx: i, printIdx: candidate };
            setPagePlan(newPlan.filter(group => group.length > 0));
            return;
          }

          // Packing is done: try once to move the footer back onto the
          // last item page (pulls may have made room since the footer was
          // split off); if the merged page overflows, the footer splits
          // off again above and the ref stops a second attempt
          if (footerOnOwnPage && !footerMergeTriedRef.current) {
            footerMergeTriedRef.current = true;
            // With a manual footer break the after-break page renders last -
            // the mergeable footer (totals part) is on the page before it
            const footerPage = pages[footerPageIdx];
            // Same outermost-footer rule as the bottom anchoring - some
            // templates nest #PageFooter inside #ContentFooter and the
            // inner one alone would badly understate the footer height
            const footerEl = findFooterBlock(footerPage);
            const lastItemPage = itemPages[itemPages.length - 1];
            if (
              footerEl &&
              lastItemPage.height + footerEl.offsetHeight <= capacity - 32
            ) {
              setFooterOnOwnPage(false);
              return;
            }
          }
        }

        if (!isPurchaseOrderType && maxHeight > capacity && current > 1) {
          setItemsPerPageFit(
            Math.max(
              1,
              Math.min(
                current - 1,
                Math.floor((current * capacity) / maxHeight),
              ),
            ),
          );
          return;
        }

        // Full measure pass with no layout change - safe to export
        setLayoutSettled(true);
      });
    };

    measure();
    // Hidden pages fill in asynchronously (queries + finalHTML effects)
    const observer = new MutationObserver(measure);
    observer.observe(wrapper, { childList: true, subtree: true });
    return () => {
      observer.disconnect();
      if (rafID !== null) cancelAnimationFrame(rafID);
    };
  }, [
    poWithRepeatedHeaders,
    remapData,
    itemsPerPageFit,
    footerOnOwnPage,
    itemPartLines,
    pagePlan,
  ]);

  /* ========================================= */
  /* DOCS THAT IS SAVED AS PDF WHICH IS HIDDEN */
  /* ========================================= */
  const pdfToPrint = () => {
    return (
      <div style={{ position: 'fixed', left: `-1000px` }}>
        {/* Size the drawn scene to the widest page content - a fixed width
            clips wider templates (e.g. 850px + 60px padding = 970px) at the
            wrapper edge in the Kendo draw, cutting the rightmost column */}
        <div id={'pdf-data-print-wrapper'} style={{ width: 'max-content' }}>
          {isPurchaseOrderType && poWithRepeatedHeaders ? (
            poWithRepeatedHeaders.map((pageData, index) => (
              <React.Fragment key={index}>
                <ELetterPreview
                  fontStyle={fontStyle}
                  title={title}
                  previewDetail={pageData}
                  allpreviewDetail={previewDetail}
                  accountType={accountType}
                  docType={docType}
                  itemName={itemName}
                  creditorOrDebtor={creditorOrDebtor}
                  submittedByLedger={submittedByLedger}
                  remapData={[pageData]}
                  page={0}
                  pageLength={poWithRepeatedHeaders.length}
                  hasItem={hasItem}
                  currencyCode={
                    pageData.companyCurrencyCode || user?.companyCurrencyCode
                  }
                  htmlTemplate={templateBody}
                  exportPagination={true}
                  isPOWithRepeatedHeaders={true}
                  pageNumber={pageData.pageNumber}
                  totalPages={pageData.totalPages}
                  threshold={
                    docType === 'rfq' ? Number.POSITIVE_INFINITY : undefined
                  }
                  approvalLog={approvalLogData}
                  watermarkData={watermarkData}
                />
                {index < poWithRepeatedHeaders.length - 1 && (
                  <div
                    className="page-break"
                    style={{
                      pageBreakAfter: 'always',
                      breakAfter: 'page',
                    }}
                  />
                )}
              </React.Fragment>
            ))
          ) : !!hasItem ? (
            previewDetail &&
            remapData &&
            remapData?.map((v, index) => {
              return (
                <React.Fragment key={index}>
                  <ELetterPreview
                    fontStyle={fontStyle}
                    title={title}
                    previewDetail={previewDetail}
                    allpreviewDetail={previewDetail}
                    accountType={accountType}
                    docType={docType}
                    itemName={itemName}
                    creditorOrDebtor={creditorOrDebtor}
                    submittedByLedger={submittedByLedger}
                    remapData={remapData}
                    page={index}
                    pageLength={remapData?.length}
                    hasItem={hasItem}
                    currencyCode={user?.companyCurrencyCode}
                    htmlTemplate={templateBody}
                    exportPagination={true}
                    threshold={
                      docType === 'rfq' ? Number.POSITIVE_INFINITY : undefined
                    }
                    approvalLog={approvalLogData}
                    watermarkData={watermarkData}
                  />
                  {index < remapData.length - 1 && (
                    <div
                      className="page-break"
                      style={{
                        pageBreakAfter: 'always',
                        breakAfter: 'page',
                      }}
                    />
                  )}
                </React.Fragment>
              );
            })
          ) : (
            <ELetterPreview
              fontStyle={fontStyle}
              title={title}
              previewDetail={previewDetail}
              allpreviewDetail={previewDetail}
              accountType={accountType}
              docType={docType}
              itemName={itemName}
              creditorOrDebtor={creditorOrDebtor}
              submittedByLedger={submittedByLedger}
              remapData={remapData}
              page={page}
              pageLength={1}
              hasItem={hasItem}
              currencyCode={user?.companyCurrencyCode}
              htmlTemplate={templateBody}
              exportPagination={true}
              threshold={
                docType === 'rfq' ? Number.POSITIVE_INFINITY : undefined
              }
              approvalLog={approvalLogData}
              watermarkData={watermarkData}
            />
          )}
          {attachmentData?.is_attached_file && attachmentData?.file?.fileURL && (
            <div
              className={
                width < 769
                  ? 'pagination-dis-mobile desc'
                  : 'pagination-dis-desktop desc'
              }
              style={{
                margin: '-32px',
                width: '14%',
                whiteSpace: 'normal',
                left: width < 769 ? '64px' : '278px',
                bottom: '91px',
              }}
            >
              *This document has an attached file that will be merged into the
              PDF during download and sharing.
            </div>
          )}
        </div>
      </div>
    );
  };

  const [openShareDialog, setOpenShareDialog] = useState(false);
  const [openSendEmail, setOpenSendEmail] = useState(false);

  const [
    shareAttachments,
    {
      loading: shareAttachmentLoading,
      data: { shareAttachment } = { shareAttachment: {} as any },
    },
  ] = useGetShareAttachmentMutation({
    onCompleted: () => {
      setOpenShareDialog(true);
    },
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrMessage(error);
      setErrDialog(true);
    },
  });

  // const onSubmit = blob => {
  //   // shareAttachments({ variables: { file: blob } });
  // };

  const onSubmit = blob => {
    shareAttachments({
      variables: {
        file: blob,
        contractID: previewDetail?.contractID,
      },
    });
  };

  // Get current page data for view mode
  const getCurrentPageData = () => {
    if (isPurchaseOrderType && poWithRepeatedHeaders) {
      return poWithRepeatedHeaders[page] || previewDetail;
    }
    return previewDetail;
  };

  // Attachment (e.g. uploaded T&C pdf) shown as one EXTRA preview tab after
  // the document pages. Preview-only: it is not part of the page plan, so
  // [PageNo]/[TotalPage] and the hidden export wrapper are unaffected - the
  // real merge still happens in finalPdf on download/share
  const hasAttachment = !!(
    attachmentData?.is_attached_file && attachmentData?.file?.fileURL
  );
  const documentPageCount = isPurchaseOrderType
    ? poWithRepeatedHeaders?.length ?? 1
    : remapData?.length ?? 1;
  const isAttachmentPage = hasAttachment && page === documentPageCount;

  return (
    <>
      {loading && <Loading />}
      {subByLoading && <Loading />}
      {currencySetupLoading && <Loading />}
      {letterTemplateLoading && <Loading />}
      {shareAttachmentLoading && <Loading />}
      {approvalLogLoading && <Loading />}
      {exporting && <Loading />}
      {!!previewDetail && !layoutSettled && <Loading />}
      <MainHeader
        mainBtn="close"
        onClick={() => {
          if (locationState?.backPath) {
            history.push({
              pathname: locationState.backPath,
            });
            return;
          }

          history.push({
            pathname: returnPath,
            state: locationState !== null ? locationState : previewDetail,
          });
        }}
        smTitle={smTitle}
        title={user?.companyName}
        routeSegments={[
          { name: `${smallTitle}` },
          { name: 'Document Template' },
          { name: `${documentName}`, current: true },
        ]}
        rightRouteSegments={[
          {
            name: (
              <span>
                Document Template
                <span
                  style={{
                    display: 'inline-block',
                    border: '1px solid #fff',
                    borderRadius: 9,
                    padding: '0 6px',
                    marginLeft: 6,
                    fontSize: 10,
                    lineHeight: '14px',
                    fontWeight: 600,
                    verticalAlign: 'middle',
                  }}
                >
                  V2
                </span>
              </span>
            ),
            current: true,
          },
        ]}
      />
      <ContentWrapper footer>
        <div>
          {isAttachmentPage ? (
            <div
              style={{
                position: 'relative',
                minHeight: '297mm',
                background: '#fff',
                boxShadow: '0 0 10px rgba(0,0,0,0.1)',
              }}
            >
              <embed
                src={attachmentData?.file?.fileURL}
                type="application/pdf"
                style={{ width: '100%', height: '297mm' }}
              />
            </div>
          ) : (
          <ELetterPreview
            fontStyle={fontStyle}
            title={title}
            previewDetail={getCurrentPageData()}
            allpreviewDetail={previewDetail}
            accountType={accountType}
            docType={docType}
            itemName={itemName}
            creditorOrDebtor={creditorOrDebtor}
            submittedByLedger={submittedByLedger}
            remapData={isPurchaseOrderType ? poWithRepeatedHeaders : remapData}
            page={page}
            pageLength={
              isPurchaseOrderType
                ? poWithRepeatedHeaders?.length ?? 1
                : remapData?.length ?? 1
            }
            hasItem={hasItem}
            currencyCode={user?.companyCurrencyCode}
            htmlTemplate={templateBody}
            exportPagination={true}
            isView={true}
            isPOWithRepeatedHeaders={isPurchaseOrderType}
            pageNumber={
              isPurchaseOrderType && poWithRepeatedHeaders
                ? poWithRepeatedHeaders[page]?.pageNumber
                : page + 1
            }
            totalPages={
              isPurchaseOrderType
                ? poWithRepeatedHeaders?.length ?? 1
                : remapData?.length ?? 1
            }
            threshold={docType === 'rfq' ? Number.POSITIVE_INFINITY : undefined}
            approvalLog={approvalLogData}
            watermarkData={watermarkData}
          />
          )}
        </div>

        <div className={`pagination-dis-${width < 769 ? 'mobile' : 'desktop'}`}>
          <Pagination
            count={documentPageCount + (hasAttachment ? 1 : 0)}
            shape="rounded"
            page={page + 1}
            onChange={(e, page) => {
              setCurrentPage(page - 1);
            }}
          />
        </div>
      </ContentWrapper>

      <div style={{ width: 1980 }}>{pdfToPrint()}</div>

      {ShareDialog({
        shareTitle: `${smallTitle} - ${title}`,
        title: `Share`,
        URL: shareAttachment?.fileURL,
        setSimple: setOpenShareDialog,
        simple: openShareDialog,
        emailShare: openSendEmail,
        setSimpleEmail: setOpenSendEmail,
      })}

      <Footer
        options={[
          {
            name: 'Share',
            onClick: async () => {
              const file = await onShare(
                `${title} (${previewDetail?.docNo}).pdf`,
              );
              // Export failure already surfaced via the error dialog
              if (file) onSubmit(file);
            },
            color: 'primary',
            props: { type: 'submit', disabled: exporting || !layoutSettled },
            startIcon: <ShareIcon style={{ fontSize: '18px' }} />,
          },
          {
            name: 'Download',
            color: 'primary',
            onClick: () => {
              onPrint();
            },
            props: { disabled: exporting || !layoutSettled },
          },
        ]}
      />

      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
    </>
  );
};
